import React from 'react';

const Question = () => {
    return (
        <div className="container mx-auto mt-20 p-5">
            <h1 className="text-4xl mb-5 text-center">Questions</h1>
            <div className="border-lime-500 border-2 p-3 rounded-md mb-5">
                <h3 className="text-2xl mb-3">How Does React Work?</h3>
                <p>While building client-side apps, a team of Facebook developers realized that the DOM is slow (The Document Object Model (DOM) is an application programming interface (API) for HTML and XML documents. It defines the logical structure of documents and the way a document is accessed and manipulated.). So, to make it faster, React implements a virtual DOM that is basically a DOM tree representation in JavaScript. So when it needs to read or write to the DOM, it will use the virtual representation of it. Then the virtual DOM will try to find the most efficient way to update the browser’s DOM.
                    Unlike browser DOM elements, React elements are plain objects and are cheap to create. React DOM takes care of updating the DOM to match the React elements. The reason for this is that JavaScript is very fast and it’s worth keeping a DOM tree in it to speed up its manipulation.
                    Although React was conceived to be used in the browser, because of its design it can also be used in the server with Node.js. </p>
            </div>
            <div className="border-lime-500 border-2 p-3 rounded-md mb-5">
                <h3 className="text-2xl mb-3">Props vs State in React</h3>

                <div class="overflow-x-auto relative">
                    <table class="w-full text-sm text-left text-gray-500 ">
                        <thead class="text-xs text-gray-700 uppercase bg-gray-50  ">
                            <tr>
                                <th scope="col" class="py-3 px-6">
                                    Props
                                </th>
                                <th scope="col" class="py-3 px-6">
                                    State
                                </th>

                            </tr>
                        </thead>
                        <tbody>
                            <tr class="bg-white border-b  ">

                                <td class="py-4 px-6">
                                    The Data is passed from one component to another.
                                </td>
                                <td class="py-4 px-6">
                                    The Data is passed within the component only.
                                </td>
                            </tr>
                            <tr class="bg-white border-b ">

                                <td class="py-4 px-6">
                                    It is Immutable (cannot be modified).
                                </td>
                                <td class="py-4 px-6">
                                    It is Mutable ( can be modified).
                                </td>
                            </tr>
                            <tr class="bg-white border-b">
                                <td class="py-4 px-6">
                                    Props can be used with state and functional components
                                </td>
                                <td class="py-4 px-6">
                                    State can be used only with the state components/class component (Before 16.0).
                                </td>
                            </tr>
                            <tr class="bg-white ">
                                <td class="py-4 px-6">
                                    Props are read-only.
                                </td>
                                <td class="py-4 px-6">
                                    State is both read and write.
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>
            <div className="border-lime-500 border-2 p-3 rounded-md mb-5">
                <h3 className="text-2xl mb-3">Uses of useEffect</h3>
                <p>By using this Hook, you tell React that your component needs to do something after render. React will remember the function you passed (we’ll refer to it as our “effect”), and call it later after performing the DOM updates. In this effect, we set the document title, but we could also perform data fetching or call some other imperative API.</p>
            </div>
        </div>
    );
};

export default Question;